import { RealEstate } from '../../@types/real-estate-api-types'
import customFetch from '../../utils/customFetch'
import { API_ENDPOINT } from '../../config'
import { GeneratedSuggestions } from '../../@types/generate-suggestion-types'
import { mapFromDtoToGeneratedSuggestions } from './converters/mapFromDtoToGeneratedSuggestions'

const url = API_ENDPOINT + '/anbieten/private-anbieter/inserieren/api/text/generate/combined'

export const generateSuggestionFromGenAi = async (realEstateObject: RealEstate): Promise<GeneratedSuggestions> => {
  const options = {
    method: 'POST',
    headers: {
      Accept: 'application/json; charset=utf-8',
      'Content-Type': 'application/json; charset=UTF-8',
    },
    credentials: 'include',
    body: JSON.stringify(realEstateObject),
  }
  const response = await customFetch(url, options)
  if (response.status !== 200) {
    throw new Error(`Cannot load suggestions, failed with ${response.status} and message ${await response.text()}`)
  }
  return mapFromDtoToGeneratedSuggestions(await response.json())
}
